import type { FaireProductEntity } from "../../entity_types/product";

export const p_dskgx8f7hn: FaireProductEntity = {
  token: "p_dskgx8f7hn",
  type: "product",
  name: "The Sauna - Cedar + Mist - 8oz Glass Candle",
  brandToken: "b_sec844xbdh",
  brandName: "Field Kit",
  imageUrl:
    "https://cdn.faire.com/fastly/8c06ac8939f3c984cef0fefe5de061c4b795c4a5b1507b50968082dadf5544c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02364a877396a58db5d6dc2dcc0e12d2cb91689bf620560e70e294ef600ed432.jpeg",
    "https://cdn.faire.com/fastly/25fd8a621771440f12aac4759de44d1b5c880452ffaaeab72457033a04c1a38a.jpeg",
    "https://cdn.faire.com/fastly/dc833dd55e56708242057c496ac105b4aba6aed10f9da99e26b37f8cd8d2622d.jpeg",
  ],
  priceDollars: 19,
  description:
    "Bundles of eucalyptus\nSlow dreamy snowfall\nA calming breath\n\n• Top notes - eucalyptus + rose\n• Mid notes - cedar + lily\n• Base notes - balsam\n\n𝗜𝗻𝗴𝗿𝗲𝗱𝗶𝗲𝗻𝘁𝘀\n• 100% soy wax\n• Clean burning cotton wick\n• Fine fragrance oils\n• Reusable glass jar\n\n𝗦𝗶𝘇𝗲\n• 8oz | 227g\n• 50+ hour burn time",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:59.337Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
